module.exports = __webpack_public_path__ + "static/media/play-circle-next.65f580b5.svg";